import axios from 'axios'
import Vue from 'vue';


const state = {
    auth: {
        user: null,
    },
}

const actions = {

getAuth({
    commit
}, full) {
    return new Promise((resolve, reject) => {
        axios.get('/api/user').then(response => {
            commit('setAuth', response.data)
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
},

}


const getters = {
    auth: state => state.auth,
}

const mutations = {
    setAuth(state, auth) {
        state.auth = auth;
    },
}

export default {
  state,
  getters,
  actions,
  mutations
}
